const hy = {
  found: 'գտնվել է ',
  item: 'արդյունք',
  popup: 'Մուտքագրեք հակման անունը կամ դրա նկարագրության մի մասը',
  placeholder: 'Որոնել',
  placeholderFull: 'Որոնել հակումներ',
};

export default hy;
